import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AdminAccessGroupCreatePage } from "@/components/pages/users/AdminAccessGroupCreatePage";
import { TenantAccessGroupCreatePage } from "@/components/pages/users/TenantAccessGroupCreatePage";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { PlatformRole } from "@/utils/accessControl";

export const GroupCreatePage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { userProfile, isLoading } = useAuthenticatedUser();
  const backTo = searchParams.get("backTo") || "/users?tab=groups";

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="text-muted-foreground">{t("common.loading")}</div>
      </div>
    );
  }

  if (userProfile?.role === PlatformRole.SUPER_ADMIN) {
    return <AdminAccessGroupCreatePage backTo={backTo} />;
  }

  return <TenantAccessGroupCreatePage backTo={backTo} />;
};
